/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type PaymentCheckoutInput = {
    priceId: string;
    quantity: number;
};
export type SubscriptionCardMutationVariables = {
    input: PaymentCheckoutInput;
};
export type SubscriptionCardMutationResponse = {
    readonly paymentCheckout: {
        readonly url: string;
        readonly message: string;
        readonly error: string;
    };
};
export type SubscriptionCardMutation = {
    readonly response: SubscriptionCardMutationResponse;
    readonly variables: SubscriptionCardMutationVariables;
};



/*
mutation SubscriptionCardMutation(
  $input: PaymentCheckoutInput!
) {
  paymentCheckout(input: $input) {
    url
    message
    error
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentCheckoutPayload",
    "kind": "LinkedField",
    "name": "paymentCheckout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1400088250b31859272b2f192cbdb2ac",
    "id": null,
    "metadata": {},
    "name": "SubscriptionCardMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionCardMutation(\n  $input: PaymentCheckoutInput!\n) {\n  paymentCheckout(input: $input) {\n    url\n    message\n    error\n  }\n}\n"
  }
};
})();
(node as any).hash = '1e41c2b1e0902a5b4a5d33b0c0548871';
export default node;
